import {Service} from "@/services/superclasses/service";
import {PaProject} from "@/interfaces/pa-project";

const api = window.contextPath + '/rest/pa-projects';

export class PaProjectService extends Service {

    public loadById = async (id: number): Promise<PaProject> => {
        return this.data(await this.get<PaProject>(api + "/" + id))
    }
}

export const paProjectService = new PaProjectService()